import React from 'react';
import { useSurvey } from './Context';
import FilterOption from './FilterOption';
import { demographics } from './Demographics';

function DemographicsPanel() {
    const { selectedDemographic, setDemographic } = useSurvey();

    const handleViewChange = (id) => {
        setDemographic(id);
    };

    return (
        <div className="demographics-panel">
            <fieldset className="demographics-filters">
                <legend className="filters-title">View By</legend>
                <div className="filter-items">
                    {demographics.map((option) => (
                        <FilterOption
                            key={option.id}
                            name="view_filter"
                            title={option.title}
                            id={option.id}
                            checked={selectedDemographic === option.id}
                            onChange={() => handleViewChange(option.id)}
                        />
                    ))}
                </div>
            </fieldset>
        </div>
    );
}

export default DemographicsPanel;
